export default "__VITE_ASSET__Dl1sBSoN__"